import React from "react";
import EmptyState from "../empty-state";
import { errorStateIllustrations } from "../../../assets/empty-states";

const STATUS_COPY = {
  400: {
    title: "La solicitud no pudo procesarse",
    subtitle: "Revise los datos enviados e intentelo nuevamente.",
  },
  401: {
    title: "Su sesion necesita validarse otra vez",
    subtitle: "Vuelva a ingresar para continuar con su cuenta.",
  },
  402: {
    title: "Esta accion requiere una validacion adicional",
    subtitle: "Consulte con caja o con un asesor para continuar.",
  },
  403: {
    title: "No tiene permisos para ver este contenido",
    subtitle: "Si cree que esto es un error, contacte a un asesor.",
  },
  500: {
    title: "Tuvimos un problema interno",
    subtitle: "Intente nuevamente en unos minutos.",
  },
};

const StatusState = ({ status = 500, title, subtitle, action }) => {
  const copy = STATUS_COPY[status] || STATUS_COPY[500];

  return (
    <EmptyState
      title={title || copy.title}
      subtitle={subtitle || copy.subtitle}
      action={action}
      tone="error"
      badge={`Error ${status}`}
      illustration={errorStateIllustrations[status] || errorStateIllustrations[500]}
      illustrationAlt={`Ilustracion de error ${status}`}
    />
  );
};

export default StatusState;
